export const ensureFullscreen = () => {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";

  const isLocalhost =
    hostname === "localhost" || hostname === "127.0.0.1";

  const isDesktopChrome =
    /Chrome/.test(navigator.userAgent) && !/Mobile/.test(navigator.userAgent);

  // ❌ iOS OR localhost desktop → skip
 if (isIOS) return;

  // ✅ Already fullscreen → do nothing
  if (document.fullscreenElement) return;

  const el = document.documentElement;

  try {
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    }
  } catch (err) {
    console.warn("Fullscreen failed safely", err);
  }
};
